// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg fill=%27gray%27 height=%2720%27 viewBox=%270 0 24 24%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discipline-picker-box_v3 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }
  
  .discipline-label_v3 {
    font-weight: 600;
    font-size: 1rem;
    color: var(--clr-grey-2);
  }
  
  .discipline-dropdown_v3 {
    width: 100%;
    padding: 10px 14px;
    font-size: 1rem;
    font-family: var(--ff-primary);
    border: 1px solid var(--clr-grey-7);
    border-radius: var(--radius);
    background-color: var(--clr-white);
    color: var(--clr-grey-1);
    box-shadow: var(--light-shadow);
    transition: var(--transition);
    appearance: none;
  
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 18px;
  }
  
  .discipline-dropdown_v3:focus {
    outline: none;
    border-color: var(--clr-primary-5);
    box-shadow: 0 0 0 3px var(--clr-primary-10);
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .discipline-dropdown_v3 {
      font-size: 0.95rem;
      padding: 9px 12px;
    }
  }
  
  @media (max-width: 480px) {
    .discipline-dropdown_v3 {
      font-size: 0.9rem;
      padding: 8px 10px;
    }
  }
  
  .loading-spinner_v3 {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    text-align: center;
    color: var(--clr-grey-6);
    font-size: 1rem;
    position: relative;
  }
  
  .loading-spinner_v3::before {
    content: "";
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.75rem;
    border: 3px solid var(--clr-grey-5);
    border-top-color: var(--clr-primary-7);
    border-radius: 50%;
    animation: spinLoader 0.8s linear infinite;
  }
  
  @keyframes spinLoader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/NewPatientScheduling/styles/DisciplinePicker.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mCAAmC;IACnC,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;;IAEhB,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,2CAA2C;EAC7C;;EAEA,eAAe;EACf;IACE;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mCAAmC;IACnC,sCAAsC;IACtC,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".discipline-picker-box_v3 {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .discipline-label_v3 {\n    font-weight: 600;\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n  }\n  \n  .discipline-dropdown_v3 {\n    width: 100%;\n    padding: 10px 14px;\n    font-size: 1rem;\n    font-family: var(--ff-primary);\n    border: 1px solid var(--clr-grey-7);\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n    color: var(--clr-grey-1);\n    box-shadow: var(--light-shadow);\n    transition: var(--transition);\n    appearance: none;\n  \n    background-image: url(\"data:image/svg+xml,%3Csvg fill='gray' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 18px;\n  }\n  \n  .discipline-dropdown_v3:focus {\n    outline: none;\n    border-color: var(--clr-primary-5);\n    box-shadow: 0 0 0 3px var(--clr-primary-10);\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .discipline-dropdown_v3 {\n      font-size: 0.95rem;\n      padding: 9px 12px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .discipline-dropdown_v3 {\n      font-size: 0.9rem;\n      padding: 8px 10px;\n    }\n  }\n  \n  .loading-spinner_v3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem 0;\n    text-align: center;\n    color: var(--clr-grey-6);\n    font-size: 1rem;\n    position: relative;\n  }\n  \n  .loading-spinner_v3::before {\n    content: \"\";\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-right: 0.75rem;\n    border: 3px solid var(--clr-grey-5);\n    border-top-color: var(--clr-primary-7);\n    border-radius: 50%;\n    animation: spinLoader 0.8s linear infinite;\n  }\n  \n  @keyframes spinLoader {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
